import React, { Component } from "react";
import PublicCatalogLayout from "../layouts/PublicCatalogLayout"
import ShippingTable from "./manifest/ShippingTable"
import ErrorBoundary from "@/utility/ErrorBoundary";
import { isClient } from "@/utility/UserUtils";
import EventSubheader from "./partials/EventSubheader"
import ShippingTableUngrouped from "./manifest/ShippingTableUngrouped"
const EventsManifestDashboard = (props) => {
  const { user, event, manifest_type} = props;


  const renderSubheader = () => {
    return (
      <>
      <div className="col-xs-12">
        <div className="manifest-tab-container">
        {renderLinkButton("shipping", "SHIPPING")}
          {renderLinkButton("onsite", "ONSITE")}
          {renderLinkButton("returns", "RETURNS")}
        </div>
      </div>
      {isClient(user) && (
        <div className="col-xs-12 mt-8 text-black max-w-[850px]">
          { renderSubHeaderCopy()}
        </div>
      )}

      </>
    )
  }

  const renderSubHeaderCopy = () => {
    switch(manifest_type) {
      case "shipping":
        return (
          <>
            This tab shows the status and shipping details of everything that is being shipped from the Jaguar Warehouse. Only Warehouse personnel can make edits to this page. 
          </>
        )
      case "onsite":
        return (
          <>
            This tab lets you check in items while on site and mark collected items that will be returned to the Jungle Warehouse at the end of the event. Use the Onsite Notes section to highlight any important details or special instructions. 
          </>
        )
      default:
        return (
          <>
            This tab shows the status of all returns to the Jaguar Warehouse.
            <br/>
            Only Warehouse personnel can make edits to this page. 
          </>
        )
    }
  }

  const renderLinkButton = (type, label) => {
    return (
      <a onClick={() => props.updateManifestType(type)} className={`manifest-tab ${manifest_type == type ? "active" : ""}`}href={`/events/${event.slug}/manifest/${type}`}>
        {label}
      </a>
    )
  }


  const renderManifest = () => {
    switch(manifest_type) {
      case "shipping":
        return (
          <ShippingTableUngrouped
            user={user}
            event={event}
            type="shipping"
           />
        )
      case "onsite":
        return (
          <ShippingTableUngrouped
            user={user}
            event={event}
            type="onsite"
           />
        )
      case "returns":
        return (
          <ShippingTable
            user={user}
            event={event}
            type="returns"
           />
        )
      default:
        if(window.location.pathname != `/events/${event.slug}/manifest/shipping`) {
          window.location = `/events/${event.slug}/manifest/shipping`
        }
        else {
          return "An error has occured"
        }
      }
    }
    

  return (
    <PublicCatalogLayout 
      currentPage="events" {...props}
      className="events-dashboard"
      classNames={{container: 'full-width-container manifest-full-bleed'}}
      subHeader={
        <EventSubheader activeTab="manifest" {...props} />
      }
    >
      <div className="events-header">Manifest</div>
      <ErrorBoundary>
        <div className="events-dashboard">

          <div className="row">
            {renderSubheader()}
          </div>

          <div className={`row ${isClient(user) ? "mt-8" : "mt-16"}`}>
            <div className="col-xs-12">
              {renderManifest()}
            </div>
          </div>
        </div>
      </ErrorBoundary>
    </PublicCatalogLayout>
  )
}

export default EventsManifestDashboard